import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

import ResidentCreateContainer from '~/containers/Residents/ResidentCreate';
import { Panel } from '@ixicare/ui';
import { ProfileTable } from '~components/DeviceTables/ProfileTable';
import { ProfileType, Permission } from '@ixicare/resources';

const ResidentsPage = () => {
  const [creationPermission, setCreationPermission] = React.useState<boolean>(false);
  const [editPermission, setEditPermission] = React.useState<boolean>(false);
  const [deletePermission, setDeletePermission] = React.useState<boolean>(false);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((value) => {
      if (value.length != 0) {
        value[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_create_profiles')) {
            if (perm.isEnabled) {
              setCreationPermission(true);
            }
          }
          if (perm.permission.name.includes('can_edit_all_profiles')) {
            if (perm.isEnabled) {
              setEditPermission(true);
            }
          }
          if (perm.permission.name.includes('can_delete_all_profiles')) {
            if (perm.isEnabled) {
              setDeletePermission(true);
            }
          }
        });
      }
    });
  }, []);

  return (
    <>
      <Panel>
        <ProfileTable
          profileType={ProfileType.Resident}
          enableBatteryLegend={true}
          editPermissions={editPermission}
          deletePermissions={deletePermission}
        />
      </Panel>
      {creationPermission && <ResidentCreateContainer />}
    </>
  );
};

export default dashboardWrapper(ResidentsPage, t('menu.dashboard.residents'));
